import { gql } from '@apollo/client';

const LIST_QUESTIONS = gql`
  fragment QuestionListItem on Question {
    id
    publicId
    title
    priority
    resolutionStatus
    assignedTopics {
      id
      name
    }
    isAnswered
    answersCount
    resources {
      id
      name
      type
      mimeType
    }
    createdBy {
      id
      email
      firstName
      lastName
      pictureURL
    }
    owners {
      id
      email
      firstName
      lastName
      pictureURL
    }
    groups {
      id
      name
      color
    }
    hasConfirmedAnswer
    duplicateQuestionIds
    latestAnswer {
      id
      description
      isFollowUp
    }
    createdAt
    updatedAt
    archivedAt
  }

  query ListQuestions(
    $filter: QuestionArgsFilter!
    $limit: Int
    $offset: Int
    $sorter: QuestionArgSorter
  ) {
    questions(
      filter: $filter
      limit: $limit
      offset: $offset
      sorter: $sorter
    ) {
      pageInfo {
        totalCount
        offset
      }
      nodes {
        ...QuestionListItem
      }
    }
  }
`;

export default LIST_QUESTIONS;
